export const initialState = {
    currentFilter: {},
};

export const ADVANCED_FILTERS_MODAL_NAME = 'advanced_filters_modal';
export const ADVANCED_FILTERS_MODAL_TITLE = 'Advanced Filters';
